import { bl_ppl_ap_tnt_comp_receiver_mapping_RowClass } from '../../../dbschema/bl_ppl_ap_tnt_comp_receiver_mapping.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolApTntCompReceiverMappingContainerModel extends BaseContainerModel {
    bl_ppl_ap_tnt_comp_receiver_mapping: bl_ppl_ap_tnt_comp_receiver_mapping_RowClass = new bl_ppl_ap_tnt_comp_receiver_mapping_RowClass();
}